var map = {
	"./account.svg": 1101,
	"./applications.svg": 1102,
	"./appstore.svg": 1103,
	"./arrowLeft.svg": 1104,
	"./bell.svg": 1105,
	"./camera.svg": 1106,
	"./card-unverified.svg": 1107,
	"./card-verified.svg": 1108,
	"./caveat-down-small.svg": 1109,
	"./caveat-down.svg": 1110,
	"./caveat-left.svg": 1111,
	"./caveat-right.svg": 1112,
	"./caveat-up-small.svg": 1113,
	"./circle-warning.svg": 1114,
	"./close-small.svg": 1115,
	"./close.svg": 1116,
	"./contact.svg": 1117,
	"./documents.svg": 1118,
	"./download.svg": 1119,
	"./error.svg": 1120,
	"./eye.svg": 1121,
	"./file.svg": 1122,
	"./filter-noty.svg": 1123,
	"./filter.svg": 1124,
	"./hatchling.svg": 1125,
	"./id-tag.svg": 1126,
	"./info.svg": 1127,
	"./interface.svg": 1128,
	"./logo-simple.svg": 1129,
	"./logo.svg": 669,
	"./logout.svg": 1130,
	"./map.svg": 1131,
	"./menu.svg": 1132,
	"./nav-accounts.svg": 1133,
	"./nav-cards.svg": 1134,
	"./nav-clients.svg": 1135,
	"./nav-dashboard.svg": 1136,
	"./nav-exchange.svg": 1137,
	"./nav-history.svg": 1138,
	"./nav-notifications.svg": 1139,
	"./nav-payments.svg": 1140,
	"./nav-team.svg": 1141,
	"./password.svg": 1142,
	"./personal-task.svg": 1143,
	"./phone.svg": 1144,
	"./plus-small.svg": 1145,
	"./security.svg": 1146,
	"./settings.svg": 1147,
	"./shareholders.svg": 1148,
	"./size.svg": 1149,
	"./succesfulPhone.svg": 1150,
	"./success.svg": 1151,
	"./survey.svg": 1152,
	"./upload.svg": 1153,
	"./verify.svg": 1154,
	"./warning.svg": 1155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1100;